import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TRACKING_VIEW } from '../Model/Models';
import { MODELS } from '../../../../Apis/Models';
import { TABLES } from '../../../../Apis/Tables';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetEquipmentDetailsById } from '../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { permissionObj } from '../../../../Helpers/permission';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const EquipmentMaterialModalApp = (props) => {
    const { item } = props;
    const { t } = useTranslation();
    const [criteria, setCriteria] = useState();
    const moduleId = `${MODELS.EQUIPMENT_ACCESS_LOG_BY_EQUIPMENT}`;
    const option = `${TABLES.EQUIPMENT_ACCESS_LOG}`;
    const [search, setSearch] = useState(false);
    const [subView, setSubView] = useState(TRACKING_VIEW.ACCESS_LOG);
    const [displayModal, setDisplayModal] = useState('');
    const equipment = useSelector((state) => state?.equipmentSlice?.equipmentDetailsById);
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const contractorId = sessionStorage.getItem('contractorId');
    // Contractors export their own tracking, employees need the permission
    const exportPermission = contractorId || DEV ||
        permission?.includes(permissionObj?.WEB_CONTRACTOR_EXPORT);

    const handleSubViewChange = (value) => {
        setSubView(value);
    };
    useEffect(() => {
        setDisplayModal('');
    }, []);

    useEffect(() => {
        dispatch(GetEquipmentDetailsById(item.id));
    }, []);

    return {
        t,
        subView,
        handleSubViewChange,
        setSubView,
        moduleId,
        criteria,
        search,
        option,
        setCriteria,
        displayModal,
        setDisplayModal,
        equipment,
        exportPermission,
    };
};

export default EquipmentMaterialModalApp;
